import "./loader.css";

/**
 * @param {object} props
 * @param {"fullScreen" | "content" | "inline"} [props.variant="fullScreen"]
 *   - **fullScreen** — fixed overlay on the entire viewport (sidebar + main). Use for standalone
 *     full-page loads (dashboard, time sheet, modals that should block everything).
 *   - **content** — fills the nearest positioned ancestor; use with {@link ContentLoader} or any
 *     `relative` wrapper so the **sidebar stays visible** on listing pages.
 *   - **inline** — no absolute fill; parent controls size/placement (e.g. flex center in a sticky strip).
 * @param {string} [props.label="Loading"] — `aria-label` for the status region.
 */
export default function Loader({ variant = "fullScreen", label = "Loading", size }) {
  const rootClass =
    variant === "content"
      ? "loader-root loader-root--content"
      : variant === "inline"
        ? "loader-root loader-root--inline"
        : "loader-root loader-root--fullscreen";

  const spinnerClass =
    size === "sm"
      ? "custom-spinner custom-spinner--sm"
      : size === "md"
        ? "custom-spinner custom-spinner--md"
        : "custom-spinner";

  return (
    <div className={rootClass} role="status" aria-live="polite" aria-label={label}>
      <div className={spinnerClass} />
    </div>
  );
}
